var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"21","height":"18","viewBox":"0 0 21 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"21","height":"6","fill":"black"}}),_c('rect',{attrs:{"y":"12","width":"21","height":"6","fill":"#F0C733"}}),_c('rect',{attrs:{"y":"6","width":"21","height":"6","fill":"#E92A2A"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }